import {createEntityAdapter, createSlice, isAnyOf, SerializedError} from "@reduxjs/toolkit";
import {RootState} from "../../../redux/store";
import {
    createOrderThunk, getOrderLastOrderOfClientThunk,
    getOrderThunk,
    listClientOrders,
    listOrdersThunk,
    listWorkerOrders,
    updateOrderThunk
} from "./orders.thunk";
import {FeOrder} from "./types";

const orderAdapter = createEntityAdapter<FeOrder>({sortComparer: (a, b) => a.estimatedFrom - b.estimatedFrom});

type ErrorMap = {
    [id: string]: SerializedError | undefined;
};

type LoadingMap = {
    list: true | false | undefined;
    [id: string]: true | false | undefined;
}

const ordersSlice = createSlice({
    name: 'orders',
    initialState: orderAdapter.getInitialState({errors: {} as ErrorMap, loadingEntities: {} as LoadingMap}),
    reducers: {},
    extraReducers: builder =>
        builder
            .addCase(createOrderThunk.fulfilled, (state, action) => {
                orderAdapter.upsertOne(state, action.payload);
                state.errors[action.payload.id] = undefined;
            })
            .addCase(createOrderThunk.rejected, (state, {error}) => {
                state.errors.create = error;
            })
            .addCase(updateOrderThunk.fulfilled, (state, action) => {
                const {id, ...changes} = action.payload;
                orderAdapter.updateOne(state, {id, changes});
                state.errors[action.payload.id] = undefined;
            })
            .addCase(updateOrderThunk.rejected, (state, action) => {
                state.errors[action.meta.arg.id] = action.error;
            })
            .addCase(getOrderThunk.fulfilled, (state, action) => {
                orderAdapter.upsertOne(state, action.payload);
                state.errors[action.payload.id] = undefined;
            })
            .addCase(getOrderThunk.rejected, (state, action) => {
                state.errors[action.meta.arg.id] = action.error;
            })
            .addCase(getOrderLastOrderOfClientThunk.fulfilled, (state, action) => {
                if (action.payload) {
                    orderAdapter.upsertOne(state, action.payload);
                }
            })
            .addMatcher(isAnyOf(listOrdersThunk.pending, listClientOrders.pending, listWorkerOrders.pending), (state) => {
                state.loadingEntities.list = true;
            })
            .addMatcher(isAnyOf(listOrdersThunk.fulfilled, listClientOrders.fulfilled, listWorkerOrders.fulfilled), (state, action) => {
                state.loadingEntities.list = false;
                state.errors.list = undefined;
                orderAdapter.upsertMany(state, action.payload);
            })
    /* .addMatcher(isAnyOf(listOrdersThunk.rejected, listClientOrders.rejected, listWorkerOrders.rejected), (state, action) => {
         state.errors.list = action.error;
     })*/
})

export const {
    selectById: selectOrderById,
    selectIds: selectOrderIds,
    selectEntities: selectOrderEntities,
    selectAll: selectAllOrders,
    selectTotal: selectTotalOrders,
} = orderAdapter.getSelectors((state: RootState) => state.orders);

export const selectOrderListLoadingState = (state: RootState) => Boolean(state.orders.loadingEntities.list);

export default ordersSlice.reducer;
